<template>
   <div :class="showFooter ? 'showFooter' : 'devvvv'"> </div>
    <footer id="colophon" class="site-footer eeee-class" v-if="showFooter">
        <div class="container-fluid">
            <FooterMenu />
        </div>

        <div class="book-appointment" style="display: none">
            <a href="https://www.skjewellery.com/consultation">Book Appointment</a>
        </div>
        <WhatsAppChat />
    </footer>

    <div class="alt-currency-switcher" v-if="showFooter"></div>

    <div v-if="userData?.data && showFooter">
    <div v-if="userData.data.userId" ref="dataLayerContainer"></div>
    <div v-if="userData.data.list_cate" ref="hotjarContainer"></div>
    <div v-if="userData.data.userId" ref="userEventContainer"></div>
  </div>
</template>

<script lang="ts" setup>
    import { ref, onMounted } from "vue";
    import WhatsAppChat from "@/components/WhatsApp.vue";
    import FooterMenu from "@/components/FooterMenu.vue";
    import AbandonCart from '~/assist/useAbandonCart';
    import { useRoute } from "nuxt/app";
    import moment from "moment"
    import { getInforCartToDataLayer } from '@/assist/MiniCart'
    const router = useRoute();
    const route = useRoute();

    const { $ajax } = useNuxtApp()
const userData = ref(null)

const dataLayerContainer = ref(null)
const hotjarContainer = ref(null)
const userEventContainer = ref(null)
const userStore = useUserStore();
const showFooter = ref<boolean>(true); 
const showCartInsiderSdk = ref<boolean>(false);
if (route.path.includes('/custom-admin/') || route.path.includes('/my-account/submission') || route.path.includes('/my-account/task')) {
    showFooter.value = false;
}
if (route.path.includes('/cart/')) {
    showCartInsiderSdk.value = true;
  }
const injectScript = (container: HTMLElement, content: string) => {
  if (!container) return
  const script = document.createElement('script')
  script.innerHTML = content
  container.appendChild(script)
}

const injectTrackingScripts = (userData) => {
// console.log('lorem--------------------------------------------------------',userData?.data);
  if (!userData?.data) return
// console.log('dataLayerContainer.value',dataLayerContainer.value);
// console.log('dataLayerContainer.value',dataLayerContainer.value);
  if (userData.data.userId && dataLayerContainer.value) {
    const dataLayerScript = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        em: "${userData.data.email || ''}",
        fn: "${userData.data.first_name || ''}",
        ln: "${userData.data.last_name || ''}",
        ph: "${(userData.data.phone_postcode || '') + (userData.data.phone || '')}",
        external_id: "${userData.data.external_id || ''}",
        ge: "${userData.data.gender || ''}",
        db: "${userData.data.birthday || ''}",
        ct: "${userData.data.city || ''}",
        st: "${userData.data.state_code || ''}",
        zp: "${userData.data.post_code || ''}",
        cn: "${userData.data.country || ''}"
      });`
    injectScript(dataLayerContainer.value, dataLayerScript)
  }

  if (userData.data.userId && hotjarContainer.value) {
    const hotjarScript = `
      window.hj('identify', "${userData.data.userId}", {
        'Signed up': "${userData.data.user_registered || ''}",
        'Last purchase category': "${userData.data.list_cate || ''}",
        'Total purchases': "${userData.data.total || ''}",
        'Last purchase date': "${userData.data.date_created || ''}"
      });`
    injectScript(hotjarContainer.value, hotjarScript)
  }

  if (userData.data.userId && userEventContainer.value) {
    const userEventScript = `
      window.dataLayer.push({
        event: 'user_data',
        user_id: "${userData.data.userId}"
      });`
    injectScript(userEventContainer.value, userEventScript)
  }
}


const loadUserTrackingData = async () => {
  try {
    // In production, uncomment the actual API call
    const response = await $ajax.get('wp-json/skj/v1/my-account/user-data');
    if (response.success) {
      userData.value = response.data
      await nextTick()
      injectTrackingScripts(response.data)
    }
  } catch (error) {
    console.error('Failed to load user tracking data:', error)
  }
}

    var firstTime = ref(true);
    const firstLoad = ref(false);
    onMounted(() => {
      //loadUserTrackingData();

        window.addEventListener('mousemove', (e) => {
            if ( firstLoad.value == false){
                
                if (userStore.isLogin) {
                 loadUserTrackingData();
                }
                firstLoad.value = true;
            }
        });
        if (window.innerWidth < 700) {
            window.addEventListener('touchstart', (e) => {
            if ( firstLoad.value == false){
                
                if (userStore.isLogin) {
                 loadUserTrackingData();
                }
                firstLoad.value = true;
            }
            });
        }

        const abandonCart = new AbandonCart();
        abandonCart.init();

        document.addEventListener("ktsMiniCartUpdated", (event) => {
            const response = event.detail;
            abandonCart.showWelcomeBackPopup(Number(response.total));
            if (abandonCart.getCartContents().length > 0) {
                if (!abandonCart.isCartOrCheckoutPage() && firstTime.value == true){
                    firstTime.value = false;
                    abandonCart.checkInitialState();
                }
            }
        });

        // insider sdk
        if (showCartInsiderSdk.value) {
          getInforCartToDataLayer(true);

        }
        // end insider sdk
    })

</script>